import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const DeleteConfirmModal = ({ isOpen, onClose, onConfirm, projectName }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-background/80 backdrop-blur-sm">
      <div className="bg-card border border-border rounded-lg shadow-xl w-full max-w-md">
        <div className="p-6">
          <div className="w-12 h-12 rounded-full bg-destructive/10 flex items-center justify-center mb-4">
            <Icon name="AlertTriangle" size={24} className="text-destructive" />
          </div>

          <h2 className="font-heading font-semibold text-xl text-foreground mb-2">
            Delete Project?
          </h2>
          <p className="text-sm text-muted-foreground mb-4">
            Are you sure you want to delete <span className="font-medium text-foreground">{projectName}</span>? This action cannot be undone and all project data will be permanently removed.
          </p>

          <div className="flex items-center gap-3">
            <Button variant="outline" onClick={onClose} fullWidth>
              Cancel
            </Button>
            <Button variant="destructive" onClick={onConfirm} fullWidth>
              Delete Project
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;